<template>
  <v-card class="left-vertical-card">
    <div class="d-flex flex-column bg-titre mb-2">
      <div class="d-flex justify-space-between">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          Mes contrats
        </div>
        <v-btn
          class="align-self-center"
          text
          @click="close"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div
        class="primary--text ml-3 intro"
        label
      >
        {{ typeCultureSelected.nom }}
      </div>
    </div>
    <BaseLoader v-if="loading" />
    <div
      v-for="(contrat, index) in contrats"
      v-else
      :key="index"
      class="mx-2"
    >
      <ContratAdherent
        :contrat="contrat"
        is-from-liste-contrats-global
        @openForm="openForm"
        @closeForm="closeForm"
        @reload="reload"
      />
    </div>
  
    <div class="d-flex justify-space-around">
      <AgrButton
        class="pa-5"
        @click="close"
      >
        Fermer
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import BaseLoader from '@/components/common/base-loader.vue'
import ContratAdherent from './contrat-adherent.vue'

export default {
  name: 'ListeContratsAdherentModal',
  components: {AgrButton, BaseLoader, ContratAdherent},
  props: {
    typeCultureSelected: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    contrats: {
      type: Array,
      default: null
    }
  },

  methods: {
    reload () {
      this.$emit('reload')
    },
    close () {
      this.$emit('close')
    },
    openForm (contrat) {
      this.$emit('openForm', contrat)
    },
    closeForm () {
      this.$emit('closeForm')
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0px !important;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}
.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>
